import { useState, useEffect } from 'react';
import { useScheduleManagementApi } from './useScheduleManagementApi';
import { getStationCounts } from '../utils/manageData';
import swal from 'sweetalert2';
import { DriverShiftStationsLowerCase } from '../../../../../utility/constants';

export const useDriverSchedules = () => {
   const [unassignedDrivers, setUnassignedDrivers] = useState([]);
   const [schedules, setSchedules] = useState([]);
   const [allCustomDriverShifts, setAllCustomDriverShifts] = useState([]);

   const [stations, setStations] = useState([]);
   const [scheduleFilters, setScheduleFilters] = useState({
      scheduleSearch: '',
      assignFilter: 'all',
      activeStation: 'all',
   });

   const [filteredSchedules, setFilteredSchedules] = useState([]);

   const {
      getAllDriverSchedules,
      getUnassignedDrivers,
      fetchingData,
      getAllCustomDriverShifts,
   } = useScheduleManagementApi();

   useEffect(() => {
      GetData();
   }, []);

   const GetData = async () => {
      let errorOccurred = false;
      // get all driver schedules
      try {
         const data = await getAllDriverSchedules();
         setSchedules(data);
         setFilteredSchedules(data);

         // set station counts
         const stationCounts = getStationCounts(data, DriverShiftStationsLowerCase);
         setStations(stationCounts);
      } catch (error) {
         console.error('Error fetching data:', error);
         setSchedules([]);
         setFilteredSchedules([]);
         setStations([]);
         errorOccurred = true;
      }

      // Get unassigned drivers
      try {
         await refetchUnassignedDrivers();
      } catch (error) {
         errorOccurred = true;
      }

      // Get custom driver shifts
      try {
         await refetchCustomDriverShifts();
      } catch (error) {
         errorOccurred = true;
      }

      if (errorOccurred) {
         swal.fire({
            title: 'Error',
            text: 'There was an error fetching the data. Please try again.',
            icon: 'error',
         });
      }
   };

   const refetchUnassignedDrivers = async () => {
      // Get unassigned drivers
      try {
         const data = await getUnassignedDrivers();
         setUnassignedDrivers(data);
      } catch (error) {
         console.error('Error fetching unassigned drivers:', error);
         setUnassignedDrivers([]);
         throw error;
      }
   };

   const refetchCustomDriverShifts = async (showLoading = true) => {
      // Get custom driver shifts
      try {
         const data = await getAllCustomDriverShifts(showLoading);
         setAllCustomDriverShifts(data);
      } catch (error) {
         console.error('Error fetching custom driver shifts:', error);
         setAllCustomDriverShifts([]);
         throw error;
      }
   };

   const filterSchedules = () => {
      const { scheduleSearch = '', assignFilter = 'all', activeStation = 'all' } = scheduleFilters;

      const lowerCaseSearchTerm = scheduleSearch.toLowerCase().trim();

      let filtered = schedules;

      if (lowerCaseSearchTerm) {
         filtered = schedules.filter((schedule) => {
            // look for schedule name and driver names in rows
            return (
               schedule.name.toLowerCase().includes(lowerCaseSearchTerm) ||
               schedule.rows.some((row) => {
                  return row.driver && row.driver.name.toLowerCase().includes(lowerCaseSearchTerm);
               })
            );
         });
      }

      if (assignFilter !== 'all') {
         filtered = filtered.filter((schedule) => schedule.rows.length <= 0);
      }

      if (activeStation !== 'all') {
         filtered = filtered.filter((schedule) => {
            // check if the station prefix matches the active station
            const stationPrefix = schedule.name.split('_')[0].toLowerCase().trim();
            return stationPrefix === activeStation.toLowerCase().trim();
         });
      }

      setFilteredSchedules(filtered);
   };

   useEffect(() => {
      filterSchedules();
   }, [scheduleFilters, schedules]);

   return {
      unassignedDrivers,
      schedules,
      allCustomDriverShifts,

      stations,
      scheduleFilters,
      setScheduleFilters,

      filteredSchedules,
      GetData,

      fetchingData,
   };
};
